import store from "@/store/store";

const storieColors = {};

export default class {
    
    id = 0;
    pk = 0;
    storieId = 0;
    router = "";
    title = "";
    thumbnail = "";
    type = "";
    closable = true;
    active = false;
    save = true;
    color = "";
    destroy = false;
    
    constructor() {
        return this;
    }
    
    setData(data){
        this.id = data.id || new Date().getTime();
        this.storieId = data.storieId;
        this.pk = data.pk;
        this.router = data.router;
        this.title = data.title;
        this.type = data.type;
        this.thumbnail = data.thumbnail;
        this.closable = data.closable;
        this.save = true;
        
        this.color = store.getters.colorByType(this.type);
        
        // if (storieColors[this.storieId]) {
        //     this.color = storieColors[this.storieId];
        // } else {
        //     this.color = store.state.defaults.ongletColors[this.storieId % 10];
        // }
        //
        // storieColors[this.storieId] = this.color;
        //
        return this;
    }
    
    updateData(data){
        this.storieId = data.storieId;
        this.router = data.router;
        this.title = data.title;
        this.thumbnail = data.thumbnail;
    }
    
    getName(){
        return this.title;
    }
    getThumbnail(){
        return this.thumbnail;
    }
    getLabelObject(){
       return  store.getters.type(this.type).label
    }
    getIconObject(){
        return  store.getters.type(this.type).icon
    }
    
    saved(){
        this.save = true;
    }
    unsave(){
        this.save = false;
    }
    
    exist(){
        return this.id > 0 && !this.destroy;
    }
}

export const saveContentOnglet = {
    objects : {
        interactive_image:{},
        annotation:{},
        content_page:{},
        panorama:{},
        video:{},
        story:{},
        stories:{},
    },
    objectExist(type,pk){
        return this.objects[type][pk] != null
    },
    objectGet(type,pk){
        return this.objects[type][pk]
    },
    objectSave(value){
        this.objects[value.objectType][value.getId()] = value;
    },
    objectDestroy(type,pk){
        delete this.objects[type][pk];
    }
}